<template>
    <div v-if="data && data.active == true && data.page_id">
        <router-link v-bind:class="customClass" v-bind:to="getPageUrlFromId(data.page_id)">{{
            data.text != '' ? data.text : 'Hier klicken'
        }}</router-link>
    </div>
    <div v-else-if="data && data.active == true && data.url">
        <a v-bind:class="customClass" v-bind:href="data.url" target="_blank">{{
            data.text != '' ? data.text : 'Hier klicken'
        }}</a>
    </div>
    <div v-else-if="data && data.active == true">
        <a v-bind:class="customClass" href="#" onclick="return false;">{{
            data.text != '' ? data.text : 'Hier klicken'
        }}</a>
    </div>
    <div v-else-if="href">
        <template v-if="isInternalLink(href)">
            <router-link v-bind:class="customClass" v-bind:to="href"><slot></slot></router-link>
        </template>
        <template v-else>
            <a v-bind:class="customClass" v-bind:href="href" v-bind:target="target"
                ><slot></slot
            ></a>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {};
    },
    components: {},
    methods: {
        isInternalLink(href) {
            return href.indexOf('http') === -1;
        }
    },
    computed: {
        ...mapGetters(['getPageUrlFromId'])
    },
    created() {},
    mounted() {},
    props: {
        data: null,
        href: null,
        target: null,
        customClass: String
    }
};
</script>
